module.exports = __webpack_public_path__ + "static/media/hashtag.95f32313.svg";